import {COLORS} from '../common/constants';

export default {
  admin: {
    header: {
      background: COLORS.WHITE,
      logout: COLORS.GRAY,
      logo: {
        color: {
          clean: COLORS.MAIN_BLACK,
          bill: COLORS.MAIN_PINK,
        },
      },
      menu: COLORS.GRAY,
    },
    sidebar: {
      background: COLORS.MAIN_BLACK,
      activeItem: COLORS.DARK_GRAY,
      activeColor: COLORS.MAIN_PINK,
    },
    screen: {
      header: COLORS.MAIN_PINK,
    },
    datatable: {
      header: COLORS.MAIN_PINK,
    },
    footer: {
      background: COLORS.WHITE,
      text: COLORS.GRAY,
      toHero: COLORS.MAIN_PINK,
    },
  },
  merchant: {
    header: {
      background: COLORS.MAIN_BLACK,
      logout: COLORS.GRAY,
      logo: {
        color: {
          clean: COLORS.WHITE,
          bill: COLORS.WHITE,
        },
      },
      menu: COLORS.WHITE,
    },
    sidebar: {
      background: `linear-gradient(${COLORS.MAIN_PINK}, ${COLORS.PURPLE_DARKER})`,
      activeItem: COLORS.PURPLE_TEXT,
      activeColor: COLORS.MAIN_PINK,
    },
    screen: {
      header: COLORS.MAIN_BLACK,
    },
    datatable: {
      header: COLORS.MAIN_BLACK,
    },
    footer: {
      background: COLORS.MAIN_BLACK,
      text: COLORS.GRAY,
      toHero: COLORS.MAIN_PINK,
    },
  },
  user: {
    header: {
      background: `linear-gradient(to right, ${COLORS.MAIN_PINK}, ${COLORS.PURPLE_DARKER})`,
      logout: COLORS.WHITE,
      logo: {
        color: {
          clean: COLORS.WHITE,
          bill: COLORS.WHITE,
        },
      },
      menu: COLORS.WHITE,
    },
    sidebar: {
      background: COLORS.PURPLE_PALE,
      activeItem: COLORS.PURPLE_PALE_DARK,
      activeColor: COLORS.WHITE,
    },
    screen: {
      header: COLORS.PURPLE_PALE,
    },
    datatable: {
      header: COLORS.PURPLE_HEADER,
    },
    footer: {
      background: `linear-gradient(to right, ${COLORS.MAIN_PINK}, ${COLORS.PURPLE_DARKER})`,
      text: COLORS.WHITE,
      toHero: COLORS.WHITE,
    },
  },
  centralpurchasing: {
    header: {
      background: COLORS.MAIN_BLACK,
      logout: COLORS.GRAY,
      logo: {
        color: {
          clean: COLORS.WHITE,
          bill: COLORS.WHITE,
        },
      },
    },
    sidebar: {
      background: `linear-gradient(${COLORS.MAIN_PINK}, ${COLORS.PURPLE_DARKER})`,
      activeItem: COLORS.PURPLE_TEXT,
      activeColor: COLORS.MAIN_PINK,
    },
    screen: {
      header: COLORS.MAIN_BLACK,
    },
    datatable: {
      header: COLORS.MAIN_BLACK,
    },
    footer: {
      background: COLORS.MAIN_BLACK,
      text: COLORS.GRAY,
      toHero: COLORS.MAIN_PINK,
    },
  },
};
